// import React from "react";
// import { useForm } from "react-hook-form";
import React, { useRef, useState } from 'react';
// Netlify Forms version: no external email service required

const Contact = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);
  const [messageStatus, setMessageStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);
    setMessageStatus('');

    const formData = new FormData(form.current);
    formData.append('form-name', 'contact');

    const encodedBody = new URLSearchParams(
      Array.from(formData.entries()).map(([key, value]) => [key, String(value)])
    ).toString();

    fetch('/?no-cache=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encodedBody
    })
      .then(() => {
        setMessageStatus('success');
        setIsSending(false);
        e.target.reset();
        window.location.assign('/thank-you');
      })
      .catch((error) => {
        console.error('Netlify form submit error', error);
        setMessageStatus('error');
        setIsSending(false);
      });
  };

  return (
    // <>
    //   <form onSubmit={handleSubmit(onSubmit)}>
    //     <div className="row">
    //       <div className="col-md-6">
    //         <div className="form-group mb-3">
    //           <input
    //             type="text"
    //             className="form-control theme-light"
    //             placeholder="Full name"
    //             {...register("name", { required: true })}
    //           />
    //           {errors.name && errors.name.type === "required" && (
    //             <span className="invalid-feedback">Name is required</span>
    //           )}
    //         </div>
    //       </div>
    //       {/* End .col-6 */}

    //       <div className="col-md-6">
    //         <div className="form-group mb-3">
    //           <input
    //             type="email"
    //             className="form-control theme-light"
    //             placeholder="Email address"
    //             {...register(
    //               "email",
    //               {
    //                 required: "Email is Required",
    //                 pattern: {
    //                   value: /\S+@\S+\.\S+/,
    //                   message: "Entered value does not match email format",
    //                 },
    //               },
    //               { required: true }
    //             )}
    //           />
    //           {errors.email && (
    //             <span className="invalid-feedback">{errors.email.message}</span>
    //           )}
    //         </div>
    //       </div>
    //       {/* End .col-6 */}

    //       <div className="col-12">
    //         <div className="form-group mb-3">
    //           <input
    //             type="text"
    //             className="form-control theme-light"
    //             placeholder="Subject"
    //             {...register("subject", { required: true })}
    //           />
    //           {errors.subject && (
    //             <span className="invalid-feedback">Subject is required.</span>
    //           )}
    //         </div>
    //       </div>
    //       {/* End .col-12 */}

    //       <div className="col-12">
    //         <div className="form-group mb-3">
    //           <textarea
    //             rows="4"
    //             className="form-control theme-light"
    //             placeholder="Type comment"
    //             {...register("comment", { required: true })}
    //           ></textarea>
    //           {errors.comment && (
    //             <span className="invalid-feedback">Comment is required.</span>
    //           )}
    //         </div>
    //       </div>
    //       {/* End .col-12 */}

    //       <div className="col-12">
    //         <div className="btn-bar">
    //           <button className="px-btn px-btn-white">Send Message</button>
    //         </div>
    //       </div>
    //       {/* End .col-12 */}
    //     </div>
    //   </form>
    // </>
    <form ref={form} onSubmit={sendEmail} name="contact" data-netlify="true">
      <div className="row">
          <input type="hidden" name="form-name" value="contact" />
          <div className="col-md-6">
            <div className="form-group mb-3">
              <input type="text" className="form-control theme-light" placeholder="Full name" name="from_name" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group mb-3">
              <input type="email" className="form-control theme-light" placeholder="Email address" name="from_email" required />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group mb-3">
              <textarea rows="4" className="form-control theme-light" placeholder="Type message" name="message" required />
            </div>
          </div>
          {messageStatus && (
            <div className="col-12">
              <div className={`form-status-message ${messageStatus}`}>
                {messageStatus === 'success' ? 'Message sent successfully!' : 'Failed to send message. Please try again.'}
              </div>
            </div>
          )}
          <div className="col-12">
            <div className="btn-bar">
              <input 
                type="submit" 
                className="px-btn px-btn-white" 
                value={isSending ? "Sending..." : "Send Message"} 
                disabled={isSending}
              />
            </div>
          </div>

        </div>
    </form>
  );
};

export default Contact;
